<template>
  <div class="contact">
    <div class="mask mask--page-title">
      <h1 class="page-title js-page-title">contact</h1>
    </div>
    <div class="content">
      <div class="wrap-mails">
        <a class="mail js-content" :href="'mailto:' + email">{{ email }}</a>
        <a class="mail js-content" href="tel:+33 6 32 44 54 27"
          >+33 6 32 44 54 27</a
        >
      </div>
      <ul class="socials no-style">
        <li class="social js-social">
          <a
            href="https://vimeo.com/paulthibault"
            target="_blank"
            class="social-link"
          >
            <svg
              width="46px"
              height="40px"
              viewBox="0 0 46 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 41.2 (35397) - http://www.bohemiancoding.com/sketch -->
              <title>vimeo-logo</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g
                id="Maquette"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Contact"
                  transform="translate(-601.000000, -867.000000)"
                  fill="#333333"
                >
                  <g id="Socials" transform="translate(601.000000, 867.000000)">
                    <g id="vimeo-logo">
                      <g id="Capa_1">
                        <path
                          d="M39.2955523,0.0806417112 C32.8973976,-0.12802139 28.5676888,3.45935829 26.300541,10.8468449 C27.4681414,10.3662032 28.6027853,10.1236364 29.7093948,10.1236364 C32.0424556,10.1236364 33.0751271,11.4324064 32.7994912,14.0568984 C32.6627433,15.6462032 31.6319978,17.9587166 29.7093948,20.9935829 C27.7791948,24.0334759 26.3374565,25.5508021 25.3796861,25.5508021 C24.1362216,25.5508021 23.0043598,23.2023529 21.9709393,18.5112299 C21.6243614,17.1296257 21.0046087,13.6115508 20.1172453,7.94812834 C19.2853086,2.70256684 17.0869627,0.251657754 13.5123636,0.596149733 C12.0002184,0.735080214 9.73499659,2.11925134 6.71177617,4.73882353 C4.50615422,6.74139037 2.27142787,8.74449198 0,10.7455615 L2.16410536,13.5382888 C4.22955534,12.0878075 5.4378163,11.3659893 5.773373,11.3659893 C7.35720923,11.3659893 8.83629098,13.8493048 10.2126513,18.8152941 C11.4463786,23.3761497 12.6905921,27.9308021 13.9303115,32.4850267 C15.7767294,37.4546524 18.0529723,39.9404278 20.7304709,39.9404278 C25.0611426,39.9404278 30.363602,35.8693048 36.6168768,27.7240642 C42.6664206,19.9263102 45.7895805,13.7826738 46.0002664,9.29187166 C46.2779353,3.29026738 44.043209,0.216898396 39.2955523,0.0806417112 Z"
                          id="Vimeo"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        </li>
        <li class="social js-social">
          <a
            href="https://www.linkedin.com/in/paul-thibault-17953bba"
            target="_blank"
            class="social-link"
          >
            <svg
              width="42px"
              height="40px"
              viewBox="0 0 42 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 41.2 (35397) - http://www.bohemiancoding.com/sketch -->
              <title>linkedin-logo</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g
                id="Maquette"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Contact"
                  transform="translate(-702.000000, -867.000000)"
                  fill="#333333"
                >
                  <g id="Socials" transform="translate(601.000000, 867.000000)">
                    <g
                      id="linkedin-logo"
                      transform="translate(101.000000, 0.000000)"
                    >
                      <g id="Capa_1">
                        <path
                          d="M41.7582449,24.5187379 L41.7582449,39.9572816 L32.8081009,39.9572816 L32.8081009,25.5527184 C32.8081009,21.9341748 31.5135591,19.4646602 28.2739037,19.4646602 C25.8008376,19.4646602 24.3291142,21.128932 23.6816491,22.738835 C23.4455365,23.3143689 23.3847608,24.1154369 23.3847608,24.921068 L23.3847608,39.9572816 L14.4316072,39.9572816 C14.4316072,39.9572816 14.5521877,15.5606796 14.4316072,13.0330097 L23.3838871,13.0330097 L23.3838871,16.8494175 C23.365732,16.8779612 23.3421402,16.9087379 23.3250531,16.9364078 L23.3838871,16.9364078 L23.3838871,16.8494175 C24.573285,15.0174757 26.6974248,12.4004854 31.4519096,12.4004854 C37.3423952,12.4003883 41.7582449,16.2486408 41.7582449,24.5187379 Z M5.06622731,0.0541747573 C2.00336509,0.0541747573 0,2.06320388 0,4.70514563 C0,7.28951456 1.94540488,9.35951456 4.94739432,9.35951456 L5.00719916,9.35951456 C8.12938079,9.35951456 10.0710964,7.28990291 10.0710964,4.70514563 C10.0122624,2.06320388 8.12938079,0.0541747573 5.06622731,0.0541747573 Z M0.531738823,39.9572816 L9.48149446,39.9572816 L9.48149446,13.0330097 L0.531738823,13.0330097 L0.531738823,39.9572816 Z"
                          id="LinkedIn"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        </li>
        <li class="social js-social">
          <a
            href="https://www.instagram.com/paulthibault/"
            target="_blank"
            class="social-link"
          >
            <svg
              width="40px"
              height="40px"
              viewBox="0 0 40 40"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <!-- Generator: Sketch 41.2 (35397) - http://www.bohemiancoding.com/sketch -->
              <title>instagram-logo</title>
              <desc>Created with Sketch.</desc>
              <defs></defs>
              <g
                id="Maquette"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Contact"
                  transform="translate(-799.000000, -867.000000)"
                  fill="#333333"
                >
                  <g id="Socials" transform="translate(601.000000, 867.000000)">
                    <g
                      id="instagram-logo"
                      transform="translate(198.000000, 0.000000)"
                    >
                      <g id="Layer_1">
                        <g id="Group">
                          <path
                            d="M28.8014118,0 L10.9774118,0 C4.92447059,0 0,4.92470588 0,10.9776471 L0,28.8016471 C0,34.8548235 4.92447059,39.7792941 10.9774118,39.7792941 L28.8014118,39.7792941 C34.8548235,39.7792941 39.7792941,34.8545882 39.7792941,28.8016471 L39.7792941,10.9776471 C39.7795294,4.92470588 34.8548235,0 28.8014118,0 Z M36.2501176,28.8016471 C36.2501176,32.9087059 32.9087059,36.2498824 28.8016471,36.2498824 L10.9774118,36.2498824 C6.87058824,36.2501176 3.52941176,32.9087059 3.52941176,28.8016471 L3.52941176,10.9776471 C3.52941176,6.87082353 6.87058824,3.52941176 10.9774118,3.52941176 L28.8014118,3.52941176 C32.9084706,3.52941176 36.2498824,6.87082353 36.2498824,10.9776471 L36.2498824,28.8016471 L36.2501176,28.8016471 Z"
                            id="Shape"
                          ></path>
                          <path
                            d="M19.8896471,9.64 C14.2376471,9.64 9.63952941,14.2381176 9.63952941,19.8901176 C9.63952941,25.5418824 14.2376471,30.1397647 19.8896471,30.1397647 C25.5416471,30.1397647 30.1397647,25.5418824 30.1397647,19.8901176 C30.1397647,14.2381176 25.5416471,9.64 19.8896471,9.64 Z M19.8896471,26.6101176 C16.184,26.6101176 13.1689412,23.5955294 13.1689412,19.8898824 C13.1689412,16.184 16.1837647,13.1691765 19.8896471,13.1691765 C23.5955294,13.1691765 26.6103529,16.184 26.6103529,19.8898824 C26.6103529,23.5955294 23.5952941,26.6101176 19.8896471,26.6101176 Z"
                            id="Shape"
                          ></path>
                          <path
                            d="M30.5696471,6.64729412 C29.8896471,6.64729412 29.2216471,6.92258824 28.7414118,7.40494118 C28.2588235,7.88494118 27.9814118,8.55317647 27.9814118,9.23552941 C27.9814118,9.91576471 28.2590588,10.5837647 28.7414118,11.0661176 C29.2214118,11.5461176 29.8896471,11.8237647 30.5696471,11.8237647 C31.252,11.8237647 31.9178824,11.5461176 32.4002353,11.0661176 C32.8825882,10.5837647 33.1578824,9.91552941 33.1578824,9.23552941 C33.1578824,8.55317647 32.8825882,7.88494118 32.4002353,7.40494118 C31.9202353,6.92258824 31.252,6.64729412 30.5696471,6.64729412 Z"
                            id="Shape"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "contact-view",

  computed: mapState({
    email: (state) => state.email,
  }),

  methods: {
    enter(done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      const $pageTitle = this.$el.querySelector(".js-page-title");
      const $content = this.$el.querySelectorAll(".js-content");
      const $social = this.$el.querySelectorAll(".js-social");

      tl.set($pageTitle, {
        y: "100%",
      });

      tl.set($content, {
        autoAlpha: 0,
        y: 35,
      });

      tl.set($social, {
        autoAlpha: 0,
        y: 25,
      });

      tl.to($pageTitle, 0.6, {
        y: "0%",
        ease: Quart.easeOut,
        force3D: true,
      });

      tl.staggerTo(
        $content,
        0.6,
        {
          autoAlpha: 1,
          y: 0,
          ease: Quart.easeOut,
          force3D: true,
        },
        0.1,
        0.1
      );

      tl.staggerTo(
        $social,
        0.8,
        {
          autoAlpha: 1,
          y: 0,
          ease: Quart.easeOut,
          force3D: true,
        },
        0.1,
        0.4
      );
    },

    leave(done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      const $pageTitle = this.$el.querySelector(".js-page-title");
      const $content = this.$el.querySelectorAll(".js-content");
      const $social = this.$el.querySelectorAll(".js-social");

      tl.to($pageTitle, 0.4, {
        y: "-100%",
        ease: Quart.easeOut,
        force3D: true,
      });

      tl.staggerTo(
        $content,
        0.4,
        {
          autoAlpha: 0,
          y: -35,
          ease: Quart.easeOut,
          force3D: true,
        },
        0.1,
        0.1
      );

      tl.staggerTo(
        $social,
        0.3,
        {
          autoAlpha: 0,
          y: -25,
          ease: Quart.easeOut,
          force3D: true,
        },
        -0.1,
        0.3
      );
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~include-media/dist/_include-media.scss";

.page-title {
  margin-bottom: 0;
}

.mask--page-title {
  margin-bottom: 0;
}

.contact {
  min-height: calc(100vh - 156px);
  display: flex;
  flex-direction: column;

  @include media("<1440px") {
    min-height: calc(100vh - 125px);
  }
}

.content {
  flex: 1;
  text-align: center;
  padding-bottom: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrap-mails {
  margin-top: auto;
  margin-bottom: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
}

.mail {
  position: relative;
  font-weight: 700;
  font-size: 36px;
  color: $text-color;
  text-decoration: none;

  &:after {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    right: 0;
    bottom: -0.1em;
    height: 0.11em;
    background-color: $text-color;
    transform: scale3d(1, 1, 1);
    transform-origin: bottom left;
    transition: transform 0.5s $easeOutQuart;
  }

  &:hover {
    &:after {
      transform-origin: bottom right;
      transform: scale3d(0, 1, 1);
    }
  }

  &:last-child {
    margin-top: 24px;
  }
}

.socials {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.social + .social {
  margin-left: 16px;
}

.social-link {
  display: block;
  padding: 0.5em;
  transition: transform 0.5s $easeOutQuart;
  width: 46px;

  svg {
    display: block;
    width: 100%;
    height: 100%;

    path {
      transition: fill 0.5s $easeOutQuart;
    }
  }

  &:hover {
    transform: scale(1.15);

    svg {
      path {
        fill: $red;
      }
    }
  }
}

@include media("<=tablet") {
  .contact {
    height: calc(100vh - 84px);
  }

  .content {
    padding-bottom: 50px;
  }
}

@include media("<=600px") {
  .mail {
    font-size: 32px;
  }

  .social-link {
    width: 40px;
  }

  .social + .social {
    margin-left: 10px;
  }
}

@include media("<=phone") {
  .mail {
    font-size: 26px;
  }
}

@include media("<=350px") {
  .mail {
    font-size: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// ContactView.vue?77037a06